import React, { Component } from "react";
import FixedView from "../FixedView";
import { nanoid } from "nanoid";
import { FormBuilderObjects, InputTypeToType, TypeToInputType } from "../../variables/formBuilderData";
import inputComponents from "./inputComponents";
import { checkTranslation, removeLangFromText, translate } from "../../utils/useful";
import StagesManager from "../StagesManager";
import EmptyInput from "./EmptyInput";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../stores/actionsList';
import { EntitiesData } from "../../variables/EntitiesData";
import HttpServices from "../../utils/Http.services";


class ParamsStageList extends React.Component {
    state = {
        items: [],



        slectedCell: [],

        search: "",
        sourceItems: [],
        sourceType: [],
        params: {},

        currentPath: [],
        currentList: [],
        currentPathItems: []
    }


    componentDidMount() {
        let current = { level: 0, groupId: 'root', parents: [] }

        if (this.props.data) {
            this.setState({ data: this.props.data })
        } else {
            this.setState({ current }, () => {
                // this.doAdd('con', current)
            })
        }
        let items = this.props.items ?? this.props.optionsList
        this.setState({ items: items }, () => {
            // this.setState({ sourceItems: this.state.items, source: this.props.prop.source, target: this.props.prop.target, operator: this.props.prop.operator })
        });
        this.init()

    }


    componentDidUpdate(prevProps) {
        // this.setState({ items: this.props.items }, () => {
        // })
        if ((this.props.params != prevProps.params) || (prevProps.items != this.props.items) || (prevProps.optionsList != this.props.optionsList)) {
            this.init()
        };
    }



    init() {


        this.createCurrentList()

        // let params = {}

        // console.log(this.props.params)

        // // if (Array.isArray(this.props.params)) {
        // //     for (let i = 0; i < this.props.params.length; i++) {
        // //         const param = this.props.params[i];
        // //         params[param.value] = { key: param.key ?? param.value, label: param.label, list: param.fields ?? param.list, info: param.info }
        // //     }
        // // } else {
        // params = this.props.params
        // // }

        // // console.log(params)


        // this.setState({ params })
    }



    openFirstView = () => {
        // this.props.setCurrent('current',{})
        // let current = { groupId: this.props.data.id, id: null, key: 'source', parents: this.props.parents }
        // if (this.props.setCurrent) {
        //     this.props.setCurrent('current', current)
        // }
        this.firstView.showView();
    };
    openSecondView = () => {
        // let current = { groupId: this.props.data.id, id: null, key: 'action', parents: this.props.parents }
        // if (this.props.setCurrent) {
        //     this.props.setCurrent('current', current)
        // }
        this.secondView.showView();
    };
    openThirdView = () => {

        this.thirdView.showView();
    };

    // saveAction = () => {
    //     this.saveSidebar.open()
    // }

    // doDone = () => {
    //     this.setState({ tempData: -1 }, () => {
    //         this.props.changeValue(this.props.header?.key, this.props.data, this.props.extra)
    //     })
    // }

    // openAdd = (id, parents, level) => {
    //     this.setState({ currentNode: this['add-' + id], current: { level, groupId: id, parents } }, () => {
    //         this.fixedView.showView()
    //     })
    // }

    // openActionsView = (id, parents, level) => {
    //     this.setState({ currentNode: this['action-' + id], current: { level, groupId: id, parents } }, () => {
    //         this.actionsView.showView()
    //     })
    // }

    // doAdd = (type, current) => {
    //     if (this.fixedView) {
    //         this.fixedView.hideView()
    //     }
    //     let id = nanoid(10)

    //     let newCondition
    //     if (type == 'con') {
    //         newCondition = { id, source: null, operator: null, target: null }
    //     } else {
    //         newCondition = { id, action: 'and' }
    //     }
    //     let data = this.props.data
    //     // let current = this.state.current
    //     current.id = id


    //     this.actionOnChild(data, current, newCondition, 'add', 0)


    //     this.setState({ data: data })
    // }

    changeAction = (type, id) => {
        let data = this.props.data
        data.action = type
        // let current = this.state.current
        // this.actionOnChild(data, current, type, 'changeOperator', 0)
        this.setState({ data }, () => {
            // if (this.props?.changeValue) {
            //     this.props.changeValue('action', data.action, this.props.extra)
            // }
            // let current = { groupId: this.props.data.id, id: null, key: 'action', parents: this.props.parents }
            // new Promise((resolve) => {

            //     if (this.props.setCurrent) {
            //         this.props.setCurrent('current', current, () => {
            //             resolve()
            //         })
            //     }
            //     else {
            //         resolve()
            //     }
            // }).then(() => {

            if (this.props.actionOnChild) {
                this.props.actionOnChild(data, this.props.current, type, 'changeOperator', 0)
            }
            this.secondView.hideView()
            // })

        })
        if (this.actionsView) {
            this.actionsView.hideView()
        }
    }

    removeRow = (groupId, id, parents) => {
        let current = { groupId, id, parents }
        let data = this.props.data
        this.actionOnChild(data, current, null, 'remove', 0)
        this.setState({ data: data })

    }

    openInput = (key, id, groupId, parents) => {
        // let current = { groupId, id, parents, key }
        // let data = this.props.data
        // if (this.props.setCurrent) {

        //     this.props.setCurrent('current', current, () => {
        //         return

        //         let value = this.props.actionOnChild(data, this.props.current, null, 'get', 0)
        //         // this.props.changeInputValue('', data.conditions[id], this.props.extra)

        //         let inputHeader = {
        //             type: 'SmartInput'
        //             , information: {}
        //         }

        //         if (key == 'operator') {
        //             inputHeader = {
        //                 type: 'SelectInput', information: {
        //                     type: 'local', items: [
        //                         { title: '{{lang}}Equal', value: 'Equal' },
        //                         { title: '{{lang}}Less Than', value: 'Less Than' },
        //                         { title: '{{lang}}More Than', value: 'More Than' },
        //                         { title: '{{lang}}Equal or less than', value: 'Equal of less than' },
        //                         { title: '{{lang}}Equal or more than', value: 'Equal of more than' },
        //                         { title: '{{lang}}Contains', value: 'Contains' },
        //                     ]
        //                 }
        //             }
        //         }

        //         this.setState({ inputHeader, currentNode: this[key + '-' + id], current: { id, groupId, parents, key, value } }, () => {
        //             this.inputView?.showView()
        //         })
        //     })
        // }

    }

    // changeInputValue = (key, value) => {
    //     let current = this.state.current
    //     let data = this.props.data
    //     // let value = target.value

    //     this.actionOnChild(data, current, value, 'update', 0)
    //     current.value = value//target.value
    //     this.setState({ data, current })
    // }

    // actionOnChild(data, current, value, action, index) {

    //     if (index == current.parents.length) {

    //         if (action == 'add') {

    //             if (!data[current.groupId]) {
    //                 data[current.groupId] = {}
    //             }
    //             if (!data[current.groupId].conditions) {
    //                 data[current.groupId].conditions = {}
    //             }
    //             data[current.groupId].conditions[current.id] = value

    //         }

    //         if (action == 'remove') {
    //             if (current.id == null) {
    //                 delete data[current.groupId]
    //             } else {
    //                 delete data[current.groupId].conditions[current.id]
    //             }
    //         }

    //         if (action == 'changeOperator') {
    //             if (!data[current.groupId]) {
    //                 data[current.groupId] = {}
    //             }
    //             data[current.groupId].action = value
    //         }

    //         if (action == 'update') {
    //             data[current.groupId].conditions[current.id][current.key] = value
    //         }

    //         if (action == 'get') {
    //             return data[current.groupId].conditions[current.id][current.key]
    //         }

    //     } else if (index < current.parents.length) {
    //         let newData = data[current.parents[index]]
    //         if (newData) {
    //             return this.actionOnChild(newData.conditions, current, value, action, index + 1)
    //         }
    //     }
    // }

    // getLabel(prop, key) {
    //     let label = prop[key]
    //     let hasValue = true
    //     if (!label) {
    //         label = translate('Choose')
    //         hasValue = false
    //     }
    //     return { label, hasValue }
    // }

    // setData = (item) => {
    //     this.setState({ labela: item, selectedChoose: true, selectedCalc: true, calca: item })
    // }


    targetSelectHandler = (item, baseKey, id, check, isFirstLevel) => {



    }



    itemSelected = (item, baseKey, id, check, isFirstLevel) => {

        if (item) {
            // console.log("itemSelected", item)
            // console.log("sourceSelectHandler", item, baseKey, id, check, isFirstLevel)
            let sourceItems = this.state.params
            let currentPath = isFirstLevel ? [] : this.state.currentPath
            let key = typeof baseKey == 'object' ? (baseKey._id ?? baseKey.key ?? baseKey.value) : baseKey
            let joinValue = this.props.joinValue ?? '.'
            let currentPathItems = this.state.currentPathItems ?? []

            // sourceType.push(key)
            if ((item?.type == "field" || item?.type == "FieldInput") && (!Array.isArray(item.fieldTypes) || item.fieldTypes.length != 1)) {

                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Type error', description: "{{lang}}This type of field can have more than one data type, so it can not be used for logical condition. Use another variable or limit this field to only one data type." })
                return

            }

            // console.log(key,sourceType)


            this.setState({ source: key, operator: "", sourceItems, currentPath }, () => {
                // if (this.props.headers || check) {
                // if (!this.props.optionsList || check) {
                let list = item?.list ?? item?.fields ?? item?.structure

                // console.log(list)

                if ((!item || !list || list.length == 0)) {

                    let final = currentPath ?? []
                    if (item) {
                        final.push(key)
                        currentPathItems.push(item)
                    }


                    if (this.props.useLabels) {
                        final = []
                        for (let l = 0; l < currentPathItems.length; l++) {
                            const currentPathItem = currentPathItems[l];
                            final.push(removeLangFromText(currentPathItem.information?.label ?? currentPathItem.name ?? currentPathItem.label))

                        }
                        // console.log(final)

                    }
                    // console.log(currentPathItems)
                    // console.log(final)

                    final = final.join(joinValue)


                    // console.log(final)

                    if (this.props.asVariable) {
                        final = '{{' + final + "}}"
                    }

                    // console.log(currentPathItems)
                    // console.log("FINAL", final,this.props.params)
                    this.props.changeValue(this.props.header?.key, final, this.props.extra)

                } else {
                    // sourceType = []
                    currentPath.push(key)
                    currentPathItems.push(item)
                    // console.log(currentPathItems)
                    this.setState({ currentPath, currentPathItems }, () => {
                        this.createCurrentList(true)
                        // this.stagesManager.changeStage('second')
                    })
                }
            })

        }
    }


    searchInput = (e) => {
        this.setState({ search: e.target.value }, () => {
            this.filterHandler(e);
        })
    }
    filterHandler = () => {
        let temp = [];

        if (Array.isArray(this.state.items)) {
            let items = [...this.state.items];
            for (let i = 0; i < items.length; i++) {
                let content = items[i];
                if (content?.information?.label.toLowerCase().includes(this.state.search.toLowerCase())) {
                    temp.push(content);
                }
            }


        } else {
            let items = { ...this.state.items };
            for (let i = 0; i < Object.values(items)?.length; i++) {
                let content = Object.values(items)[i];
                if (content?.label.toLowerCase().includes(this.state.search.toLowerCase())) {
                    temp.push(content);
                }
            }

        }
        this.setState({ sourceItems: temp }, () => {
        });
    };


    // changeTargetValue = (key, value, extra) => {
    //     let data = this.props.data
    //     data.conditions[extra.id].target = value



    //     // this.setState({ target: value, data }, () => {
    //     // let data = this.props.data
    //     // data.conditions[extra.id].target = value

    //     // if (this.props?.changeValue) {
    //     //     this.props.changeValue(extra.id, data.conditions[extra.id], this.props.extra)
    //     // }
    //     let current = { groupId: this.props.data.id, id: null, key: 'target', parents: this.props.parents }
    //     // new Promise((resolve) => {

    //     //     if (this.props.setCurrent) {
    //     //         this.props.setCurrent('current', current, () => {
    //     //             resolve()
    //     //         })
    //     //     }
    //     //     else {
    //     //         resolve()
    //     //     }
    //     // }).then(() => {

    //     if (this.props?.changeInputValue) {

    //         this.props.changeInputValue("target", value, current, this.props.extra)

    //         // this.props.changeInputValue('', value, this.props.extra)
    //     }
    //     // })
    //     // })
    // }



    // setSourceAsObject = (item) => {

    //     // console.log("setSourceAsObject", item)

    //     let sourceType = this.state.sourceType
    //     let currentPathItems = this.state.currentPathItems

    //     let key = item.key

    //     sourceType.push(key)
    //     currentPathItems.push(item)


    //     this.setState({ tempCurrentSourceObject: item, sourceType }, () => {
    //         this.stagesManager.changeStage('object')
    //     })
    // }

    // goToPreviousStage = () => {

    //     let currentPath = this.state.currentPath
    //     let currentPathItems = this.state.currentPathItems
    //     currentPath.pop()
    //     currentPathItems.pop()

    //     // this.stagesManager.lastStage()
    //     this.setState({ currentPath, currentPathItems }, () => {
    //         this.createCurrentList()
    //     })
    // }

    goToPreviousStage = () => {

        let currentPath = this.state.currentPath
        let currentPathItems = this.state.currentPathItems

        // if (currentPath.length == 0) {
        //     // this.props.goToMain()
        // } else {

        currentPath.pop()
        currentPathItems.pop()
        this.setState({ currentPath, currentPathItems }, () => {
            this.createCurrentList()
        })
        // }

    }



    createCurrentList = (setValue, isRelation) => {

        // console.log("createCurrentList",this.props.params)
        let promises = []
        let rawList
        let finalList = []
        let currentItem
        let currentIndex

        if (!isRelation) {

            promises.push(new Promise((resolve, reject) => {


                let params = this.props.params
                let paramsList = params
                if (params && typeof paramsList == 'object') {
                    paramsList = Object.values(params)
                }

                // console.log(paramsList)

                this.getListFromArray(paramsList, 0, (currentList, rawCurrentItem, rawCurrentIndex) => {


                    // console.log(currentList, currentItem, currentIndex)

                    rawList = currentList
                    currentItem = rawCurrentItem
                    currentIndex = rawCurrentIndex

                    resolve()

                    // console.log(validTypes)



                })

            }))

        } else {

            promises.push(new Promise((resolve, reject) => {

                // console.log("FETCH RELATION")
                this.getRelationsInfo((currentList) => {

                    currentIndex = this.state.currentPath.length
                    currentItem = { key: 'relation', type: 'relation', information: { label: "{{lang}}Relation info" } }
                    // console.log("currentList", currentList)
                    rawList = currentList
                    resolve()

                })

            }))
        }


        Promise.all(promises).then(() => {



            if (rawList) {

                this.getValidList(rawList, finalList)

            }


            if (setValue || (!finalList || finalList.length == 0)) {

                this.itemSelected()
            }


            this.setState({ currentList: [] }, () => {
                this.setState({ currentList: finalList, currentItem, currentIndex }, () => {
                    if (this.mainList) {
                        this.mainList.scrollTo(0, 0)
                    }
                })
            })

        })


    }



    getRelationsInfo = (cb) => {

        // console.log(this.props.variables)

        let params = this.props.params
        if (Array.isArray(params)) {
            let relationInfo = params.filter((a) => a.type == 'relation')[0]
            cb(relationInfo?.fields)
        }

    }

    // fetchRelationsInfo = (cb) => {

    //     // console.log(this.props.variables)

    //     let body = { appletHub: this.props.variables?.appletHub }
    //     this.setState({ isLoadingList: true })
    //     console.log(body)
    //     HttpServices.request('getRelationsFields', body, (fetchResult, fetchError) => {

    //         this.setState({ isLoadingList: false })
    //         console.log(fetchResult, fetchError)
    //         if (fetchError) {
    //             return
    //         }

    //         cb(fetchResult.info)

    //     })

    // }



    getValidList = (currentList, finalList) => {

        // let validTypes = this.props.validTypes

        for (let i = 0; i < currentList.length; i++) {
            const item = currentList[i];
            let valid = true
            let extendable = false

            this.analysisValidTypes(item, (myValid, myExtendable) => {

                valid = myValid
                extendable = myExtendable
            })

            if (valid || extendable) {
                finalList.push({ valid, extendable, item })
            }
        }

        return finalList

    }



    analysisValidTypes = (item, cb) => {

        let validTypes = this.props.validTypes



        let type = (item.dataType ?? item.type)
        let dataType = (InputTypeToType[(item.dataType ?? item.type)] ?? type) ?? 'object'

        if (dataType == 'field' && Array.isArray(item.fieldTypes) && item.fieldTypes.length == 1) {
            dataType = item.fieldTypes[0]
        }

        // console.log(dataType)

        let valid = validTypes ? validTypes.includes(dataType) : true


        let extendable = false


        // console.log(dataType, item)
        if (EntitiesData[dataType] || dataType == "record" || dataType == "object" || dataType == "permission") {

            let list = this.getListFromItem(item, dataType)


            if (!Array.isArray(list) || list.length == 0) {
                cb(valid, extendable)
                return
            } else {

                // console.log("list", list)

                for (let i = 0; i < list.length; i++) {
                    const element = list[i];
                    this.analysisValidTypes(element, (myValid, myExtendable) => {
                        if (myValid || myExtendable) {
                            extendable = true
                        }
                    })
                }
            }
        }

        // console.log(dataType, item, valid, extendable)


        cb(valid, extendable)

    }



    getListFromArray = (array, index, cb) => {

        let myKey = this.state.currentPath[index]
        let list


        // console.log("params", array)

        if (myKey) {
            for (let i = 0; i < array.length; i++) {
                const element = array[i];
                if (element.key == myKey || element._id == myKey || element.value == myKey) {

                    let dataType = InputTypeToType[(element.dataType ?? element.type)] ?? (element.dataType ?? element.type)

                    let list = this.getListFromItem(element, dataType)

                    if (!list) {
                        cb(list, null, (index + 1))
                        return
                    }

                    if (index == this.state.currentPath.length - 1) {
                        cb(list, element, (index + 1))
                    } else {
                        this.getListFromArray(list, (index + 1), cb)
                    }
                }
            }
        } else {
            list = array.filter((a) => !a.hidden)
            cb(list, null, index)
        }


    }


    getListFromItem = (item, dataType) => {

        // console.log("getListFromItem",item, dataType)
        let list
        if (item.structure) {
            list = item.structure
        }

        if (item.list) {
            list = item.list
        }

        if (item.fields) {
            list = item.fields
        }

        if (!list) {


            if (dataType == 'field' && Array.isArray(item.fieldTypes) && item.fieldTypes.length == 1) {
                dataType = item.fieldTypes[0]
            }
            let entity = EntitiesData[dataType]
            // console.log(dataType, entity,item.permissions)

            if (entity) {
                list = Object.values(entity)

                // console.log(list)
                // console.log(index, this.state.currentPath.length - 1)
                // this.getListFromArray(list, (index + 1), cb)

            } else if (item.permissions) {
                list = Object.values(item.permissions)
            }

        }

        return list

    }


    expandItem = (e, item, baseKey) => {
        e.stopPropagation();
        // console.log(item)

        // console.log("expandItem", item, baseKey)


        let currentPath = this.state.currentPath ?? []
        let currentPathItems = this.state.currentPathItems ?? []

        let key = typeof baseKey == 'object' ? (item._id ?? item.key ?? item.value) : baseKey


        currentPath.push(key)
        currentPathItems.push(item)

        this.setState({ currentPath, currentPathItems }, () => {

            // console.log(currentPath)
            this.createCurrentList(null, item.type == 'relation')

        })

    }



    render() {

        // let joinValue = this.props.joinValue ?? '.'

        // let sourceItems = this.state.params
        // let tempCurrentSourceObject = this.state.tempCurrentSourceObject
        // let sourceItemChild = sourceItems?.[this.state.source]

        let currentItem = this.state.currentItem

        return (
            <>
                <StagesManager height={'100%'} ref={e => this.stagesManager = e} fast={true}>


                    <div stage={0} ref={el => this.mainList = el} stageName='main' className="h-100 scroll-no-scrollbar " style={{ minHeight: 35, maxHeight: 200 }}>

                        <div className="bb-gray w-100 px-2 py-2 flexc " style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>
                            {this.props?.hasPreviousPage || this.state.currentItem && (
                                <button className="flexcc" onClick={() => { this.goToPreviousStage() }}>
                                    <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '18px' }} alt="" />
                                </button>
                            )}
                            {this.state.currentItem ? (
                                <p className="text-small text-bold">{(translate(((currentItem.label ?? currentItem.title) ?? (currentItem.name ?? currentItem?.information?.label))))}</p>
                            ) : (
                                <p className="text-small text-bold">{(translate("Parameters"))}</p>
                            )}
                        </div>


                        <div className="pb-1 pt-1 w-100 h-100" style={{ flex: 1, borderRadius: 4, position: 'relative', }}>

                            <div className="w-100 d-flex flex-column">

                                {this.state.currentList?.length == 0 && (
                                    <div className="px-2 py-2">
                                        <p className="text-smaller">{translate("No dynamic parameter found")}</p>
                                    </div>
                                )}

                                {Array.isArray(this.state.currentList) && this.state.currentList?.map((option, index) => {
                                    let item = option.item
                                    let label = (item.label ?? item.title) ?? (item.name ?? item?.information?.label)
                                    let key = item._id ?? item.key ?? item.value
                                    let type = (item.dataType ?? item.type)?.toLowerCase()
                                    let dataType = InputTypeToType[(item.dataType ?? item.type)] ?? type

                                    let isObject = false
                                    let isValid = option.valid
                                    let canExpand = false
                                    let currentDataPath = this.state.currentDataPath
                                    if (currentDataPath) {
                                        currentDataPath = this.state.currentDataPath[this.state.currentIndex]
                                    }
                                    let isSelected = (key == (currentDataPath?._id ?? currentDataPath?.key ?? currentDataPath?.value))

                                    if (type == 'field' || type == 'FieldInput') {
                                        if (Array.isArray(item.fieldTypes) && item.fieldTypes.length == 1) {
                                            type = item.fieldTypes[0]
                                        }
                                    }

                                    if (type) {
                                        type = TypeToInputType[type] ?? (item.dataType ?? item.type)
                                    }

                                    canExpand = option.extendable

                                    if ((dataType == 'object' || dataType == 'record' || dataType == 'relation' || !dataType || option?.item.list || option?.item.fields || option?.item.structure)) {
                                        isObject = true
                                    }

                                    // console.log(type)
                                    if (type == 'StaticText') {
                                        isValid = false
                                    }


                                    // console.log(dataType)


                                    if (isValid && label)
                                        return (
                                            <button key={key} className={"py-2 px-2  w-100 text-start hover-fields"} onClick={(e) => { if (isValid && !isObject) { this.itemSelected(item, key) } else { this.expandItem(e, item, key) } }} style={{ backgroundColor: isSelected ? '#007aff20' : '' }}>
                                                <div className="flexcb " >

                                                    <div className="flexc">
                                                        {(type && FormBuilderObjects[type]) ? (
                                                            <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                                <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[type]?.icon} width="18px" alt="" />
                                                            </div>
                                                        ) : (
                                                            < div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                                <img className="mx-1" style={{ opacity: 0.8 }} src={'/assets/icons/useful/brackets-curly.svg'} width="12px" alt="" />
                                                            </div>
                                                        )}


                                                        <div className="">
                                                            <p className="text-small text-semibold">{checkTranslation(label)}</p>


                                                            {/* {item.list && (
                                                                    <p className="text-smaller color-gray-2 ">{item.list?.length} items</p>
                                                                )}
                                                                {item.structure && (
                                                                    <p className="text-smaller color-gray-2 ">{item.structure?.length} items</p>
                                                                )} */}

                                                            {(canExpand && !isObject) && (
                                                                <button className="flexc" onClick={(e) => { this.expandItem(e, item, key) }}>
                                                                    <p className="text-smaller text-link ">{translate("Expand")}</p>
                                                                </button>
                                                            )}

                                                        </div>


                                                    </div>

                                                    {isObject && (
                                                        <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />
                                                    )}
                                                </div>


                                            </button>
                                        )
                                })}


                            </div>
                        </div>
                    </div>

                    {/* <div stage={1} stageName='main' className="h-100 scroll-no-scrollbar " style={{ minHeight: 35, maxHeight: 200 }}>
                        <div className="fields-search flexc p-1 w-100 top-0 " style={{ zIndex: 1, background: "#fff", borderBottom: '1px solid #eee', overflow: 'hidden', position: 'sticky', borderTopRightRadius: 7, borderTopLeftRadius: 7 }}>
                            <img src="/assets/icons/gantt/search.svg" className="mld-1" alt="" />
                            <input type="search" name="name" className="fields-search text-smaller p-1 w-100 text-semibold " style={{ borderBottom: 'none', }} placeholder={translate("Search ...")} value={this.state.search} onChange={(e) => this.searchInput(e)} />
                        </div>
                        <div className="pb-2 pt-2 w-100 h-100 d-flex flex-column" style={{ flex: 1, borderRadius: 4, position: 'relative', }}>
                            {Array.isArray(sourceItems) ? (
                                <>
                                    {
                                        sourceItems?.map((item, index) => {

                                            let label = item?.information?.label ?? item.label ?? item.name

                                            return (
                                                <button key={index} className="flexc p-1 px-2 mb-1 grayscale-filter action w-100" style={{ cursor: "pointer" }} onClick={() => this.sourceSelectHandler(item, item, null, null, true)}>
                                                    <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                        <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[item.type]?.icon} width="18px" />
                                                    </div>
                                                    <p className="text-small text-semibold">{checkTranslation(label)}</p>
                                                </button>
                                            )
                                        })
                                    }
                                </>
                            ) : (
                                <>
                                    {sourceItems && Object.values(sourceItems)?.map((item, index) => {

                                        let label = item?.information?.label ?? item.label ?? item.name

                                        return (
                                            <button key={index} className="p-1 px-2 my-1 w-100 text-start" onClick={() => this.sourceSelectHandler(item, item.key, null, null, true)}>
                                                <div key={index} className="flexcb " >
                                                    <div className="flexc">
                                                        <p className="text-small text-semibold">{checkTranslation(label)}</p>
                                                    </div>
                                                    <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />

                                                </div>

                                                <p className="text-smaller color-gray-2">{item.list?.length ?? item.fields?.length} items</p>

                                            </button>
                                        )
                                    })
                                    }

                                </>
                            )}
                        </div>
                    </div> */}

                    {/* <div stage={1} stageName='second' className="mt-2" style={{ minHeight: '100px' }}>
                        {sourceItems && (sourceItemChild?.list ?? sourceItemChild?.fields)?.length != 0 ? (
                            <div className="scroll-no-scrollbar" style={{ maxHeight: '200px' }}>
                                <div className="bb-gray w-100 px-2 pb-2 flexc " style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>
                                    <button className="flexcc" onClick={() => { this.goToPreviousStage() }}>
                                        <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '16px' }} alt="" />
                                    </button>
                                    <p className="text-small text-semibold">{(checkTranslation(sourceItemChild?.label ?? sourceItemChild?.information?.label))}</p>
                                </div>
                                <div className="pt-1">
                                    {sourceItems && (sourceItemChild?.list ?? sourceItemChild?.fields)?.map((element) => {
                                        let name = element.name ?? element?.information?.label ?? element?.label
                                        let key = element._id ?? element.key
                                        let type = (element.dataType ?? element.type)?.toLowerCase()
                                        let isObject = false


                                        if (type == 'field' || type == 'FieldInput') {
                                            if (Array.isArray(element.fieldTypes) && element.fieldTypes.length == 1) {
                                                type = element.fieldTypes[0]
                                            }
                                        }


                                        if (type) {
                                            type = TypeToInputType[type] ?? (element.dataType ?? element.type)
                                        }
                                        if (type == 'object' || type == 'ObjectInput' || type == 'record' || type == 'RecordInput') {
                                            isObject = true
                                        }

                                        return (

                                            <button key={key} className="flexcb p-1 px-2 mb-1 grayscale-filter  w-100 text-start" onClick={() => isObject ? this.setSourceAsObject(element) : this.sourceSelectHandler(element, key, null, true)}>
                                                <div className="flexc">
                                                    <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                        <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[type]?.icon} width="18px" alt="" />
                                                    </div>
                                                    <p className="font-size-13 text-semibold">{checkTranslation(name)}</p>
                                                </div>
                                                {isObject && (
                                                    <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />
                                                )}
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>
                        ) : (
                            <div className="w-100 px-2 py-2">
                                <div className="bb-gray w-100 flexc mb-2">
                                    <button className="flexcc" onClick={() => { this.goToPreviousStage() }}>
                                        <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '16px' }} alt="" />
                                    </button>
                                    {sourceItems && (
                                        <p className="text-smaller main-c2">{(sourceItemChild?.label ?? sourceItemChild?.information?.label)?.length > 20 ? (sourceItemChild?.label ?? sourceItemChild?.information?.label)?.substring(0, 20) + '...' : (sourceItemChild?.label ?? sourceItemChild?.information?.label)}</p>
                                    )}
                                </div>
                                <p className="text-smaller">{translate("Not found")}</p>
                            </div>
                        )}
                    </div> */}



                    {/* <div stage={1} stageName='object' className="mt-2" style={{ minHeight: '100px' }}>
                        {tempCurrentSourceObject && tempCurrentSourceObject?.structure?.length != 0 && (
                            <div className="scroll-no-scrollbar" style={{ maxHeight: '200px' }}>
                                <div className="bb-gray w-100 px-2 py-2 flexc " style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>
                                    <button className="flexcc" onClick={() => { this.goToPreviousStage() }}>
                                        <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '16px' }} />
                                    </button>
                                    <p className="text-small text-semibold">{(checkTranslation(tempCurrentSourceObject?.name))}</p>
                                </div>

                                <div className="pt-1">

                                    {(tempCurrentSourceObject?.structure == null || tempCurrentSourceObject?.structure?.length == 0) && (
                                        <div className="flexcc py-2">
                                            <p className="text-smaller text-semibold">{translate("Found nothing")}</p>
                                        </div>
                                    )}

                                    {tempCurrentSourceObject?.structure?.map((element) => {
                                        let name = element.name ?? element?.information?.label
                                        let key = element._id ?? element.key
                                        key = tempCurrentSourceObject?.key + joinValue + key
                                        let type = (element.dataType ?? element.type)?.toLowerCase()
                                        let isObject = false
                                        if (type) {
                                            type = TypeToInputType[type] ?? (element.dataType ?? element.type)
                                        }
                                        // console.log(type)
                                        if (type == 'object' || type == 'ObjectInput' || type == 'record' || type == 'RecordInput') {
                                            isObject = true
                                        }

                                        return (

                                            <button key={key} className="flexcb p-1 px-2 mb-1 grayscale-filter  w-100" onClick={() => isObject ? this.setSourceAsObject(element) : this.sourceSelectHandler(element, key, null, true)}>
                                                <div className="flexc">
                                                    <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                        <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[type]?.icon} width="18px" />
                                                    </div>
                                                    <p className="text-small text-semibold">{checkTranslation(name)}</p>
                                                </div>
                                                {isObject && (
                                                    <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />
                                                )}
                                            </button>
                                        )
                                    })}

                                </div>
                            </div>
                        )}
                    </div> */}
                </StagesManager>
            </>

        )
    }
}
// export default ParamsStageList;

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(ParamsStageList);